module.exports = __webpack_public_path__ + "media/assets/triangle-b36b26987b08246f1ecac3afcd4f2c1a.svg";